module.exports = __webpack_public_path__ + "img/91866.ffacb51a.svg";